import collapsible from '../../modules/module--collapsible';

export default function($element) {
    const module = collapsible.add({
        block:
            '#menu .menu-main .menu-main__item--has-children.menu-main__item--l1, #menu .menu-settings .menu-settings__item--has-children.menu-settings__item--l1',
        elToggle:
            '#menu .menu-main .menu-main__link--has-children.menu-main__link--l1, #menu .menu-settings .menu-settings__link--has-children.menu-settings__link--l1',
        elContent: '#menu .menu-main .menu-main__list--l2, #menu .menu-settings .menu-settings__list--l2',
        classOpenLoad: 'menu-main__link--has-active',
        closeOutside: false,
        closeAny: false,
        closeOthers: true,
        breakpoint: ['mobile', 'tablet', 'laptop'],
        callbackOpenAfter() {
            $('.menu-main__body').addClass('menu-main--l2-open');
        },
        callbackAfterFire() {
            // Exception: Prevent Click for Project Review menu item as it's children are not active before project is selected
            $('.menu-main__item--exclude .menu-main__link--has-children.menu-main__link--l1').off('click');
        },
        callbackBuilt({ elToggle, elToggleRemote }) {
            const { close } = module;
            return function cb() {
                // Make Close Button
                $(elToggle).each(function(i, el) {
                    const $elToggle = $(el);
                    const $elCloseBtn = $(`<button class="menu-main__close">${$elToggle.text()}</button>`);
                    if (!$elToggle.siblings().hasClass('menu-main__close')) {
                        $elToggle.before($elCloseBtn);
                    }
                });
                $('.menu-main__close').on('click', function() {
                    close($(this).next());
                    $('.menu-main__body').removeClass('menu-main--l2-open');
                });
            };
        },
        debug: false
    });
}
